import { Info, MoreHoriz, Upload } from '@mui/icons-material';
import { Card, CardContent, CardHeader, Chip, Container, CssBaseline, Grid, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs';
import MyDialog from '../../../../components/MyDialog';
import MyTable from '../../../../components/MyTable';
import { AuthStore, NotifStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';

const Menux = ({ data = {} }) => {
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogData, setDialogData] = useState({});
    const [openDialog, setOpenDialog] = useState(false);

    const openOption = Boolean(anchorEl);

    const handleOpenDialog = () => {
        // console.log(data);
        setDialogData(data)
        handleCloseOption();
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleOption = (event) => {
        setDialogData(data);
        setAnchorEl(event.currentTarget);
        console.log(dialogData);
    };

    const handleCloseOption = () => {
        setAnchorEl(null);
        console.log(anchorEl.event);
    };

    return (
        <>
            <Tooltip title="Pilihan">
                <IconButton aria-label="option" onClick={handleOption}>
                    <MoreHoriz />
                </IconButton>
            </Tooltip>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openOption}
                onClose={handleCloseOption}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleOpenDialog}>
                    <ListItemIcon>
                        <Info color="info" />
                    </ListItemIcon>
                    Info
                </MenuItem>
                {
                    data.progres === "6" ?
                        <MenuItem component={Link} to="upload" state={dialogData}>
                            <ListItemIcon>
                                <Upload color="success" />
                            </ListItemIcon>
                            Upload SP2D
                        </MenuItem>
                        : ""
                }
            </Menu>

            <MyDialog dialogData={dialogData} openDialog={openDialog} handleCloseDialog={handleCloseDialog} decryptedUser={decryptedUser} />
        </>
    )
}

const ProsesSp2d = () => {
    // const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [menyimpan, setMenyimpan] = useState(false)
    const [reqData, setReqData] = useState(true);

    const pemberitahuans = NotifStore((state) => state.pemberitahuans);

    useEffect(() => {
        console.log(pemberitahuans);
        pemberitahuans.length > 0 && setReqData(!reqData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pemberitahuans]);

    const handleLabel = (params) => {
        let label = "";

        switch (params) {
            case "4":
                label = "Penerbitas SP2D";
                break;
            case "5":
                label = "SP2D Ditandatangani"
                break;
            case "6":
                label = "SP2D Diserahkan";
                break;

            default:
                break;
        }

        return label;
    }

    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Menux data={params.row} menyimpan={menyimpan} setMenyimpan={setMenyimpan} />
                );
            }
        },
        {
            field: 'progres',
            headerName: 'Status',
            sortable: false,
            filterable: false,
            hideable: false,
            width: 200,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Chip
                        label={handleLabel(params.row.progres)}
                        color="primary"
                        variant="outlined"
                    />
                )
            },
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    const requestData = () => {
        console.log('req data');
        setTableLoading(true)
        axios.get(
            base_url + '/bnd/pencairan/proses_sp2d',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menyimpan, reqData]);

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={{ '/bnd': 'Home', '': 'Proses SP2D' }} title="Proses SP2D" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Card>
                            <CardHeader
                                title="Proses SP2D"
                            />
                            <CardContent>
                                <MyTable
                                    rows={tableData}
                                    columns={columns}
                                    row_id={(row) => row.no_spm}
                                    isLoading={tableLoading}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

export default ProsesSp2d